import { render, staticRenderFns } from "./new-detail.vue?vue&type=template&id=e833831c&scoped=true&"
import script from "./new-detail.vue?vue&type=script&lang=js&"
export * from "./new-detail.vue?vue&type=script&lang=js&"
import style0 from "./new-detail.vue?vue&type=style&index=0&id=e833831c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e833831c",
  null
  
)

export default component.exports